import script from "./CardInvoiceInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardInvoiceInfo.vue?vue&type=script&setup=true&lang=ts"

import "./CardInvoiceInfo.vue?vue&type=style&index=0&id=ff315e50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff315e50"]])

export default __exports__